
export enum DrillWidgetType {
	DEFAULT = 'default',
	NUMERIC = 'numeric',
	TREND = 'trend',
	SELECTIVE_PREVIEW = 'selectivePreview'
}


